/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SavePersonDocumentApprovalResponseViewModel } from "../types/SavePersonDocumentApprovalResponseViewModel.ts";

export const savePersonDocumentApprovalResponseViewModelSchema = z.object({
  success: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o salvamento e o recálculo da documentação foram concluídos.",
      ),
  ),
  studentName: z
    .string()
    .describe("Nome do aluno anterior à edição (exibido no toast da tela).")
    .nullish(),
}) as unknown as ToZod<SavePersonDocumentApprovalResponseViewModel>;
